import React, { useEffect } from 'react';
import useBundleTranslation from 'i18n';
import { FormControlProps, FormElementControlPropsType } from 'components/common/form/layout/control';
import { FormComponentBuilder } from 'components/common/form/layout';
import IconLink from 'components/common/icon-link/IconLink';

interface RegenerateInsightDescriptionButtonProps extends FormControlProps {}

export default function RegenerateInsightDescriptionButton({
    controlProps,
    elementProps,
}: FormElementControlPropsType<RegenerateInsightDescriptionButtonProps>) {
    const { t } = useBundleTranslation(elementProps?.translationNS ?? 'app/editor/element/extreport');

    useEffect(() => {
        const subscription = controlProps.form.hookFormWatch((_, { name, type }) => {
            if (name === 'description' && type === 'change') {
                controlProps.form.hookFormSetValue('description_overridden_ind', 'Y', { shouldDirty: true });
            }
        });
        return () => subscription.unsubscribe();
    }, []);

    const handleClick = () => {
        controlProps.form.hookFormSetValue('description_overridden_ind', 'N');
        controlProps.form.hookFormSetValue('regenerate_description', 'Y');
        controlProps.form.hookFormSetValue('description', '');
    };

    return (
        <IconLink
            indent={0.5}
            icon="refresh-cw"
            onClick={handleClick}
            dataTest={controlProps.uid ?? 'insight-regenerate-description'}
        >
            {t(controlProps.label as string)}
        </IconLink>
    );
}

export class RegenerateInsightDescriptionButtonBuilder extends FormComponentBuilder {
    prepareProps(): RegenerateInsightDescriptionButtonProps {
        return {
            ...this.controlProps,
        };
    }
}
